<!-- export running -->
@if (!isDone) {
    <div>
        <h3 mat-dialog-title>{{ 'GeneralMeeting.Exporting' | translate }}</h3>
        <div class="center">
            <mat-spinner [diameter]="50" />
        </div>
    </div>
}
<!-- export successful -->
@if (isDone && !hasError) {
    <div>
        <h3 mat-dialog-title class="title-with-icon">
            <mat-icon class="color-success">check</mat-icon>
            <span>{{ 'GeneralMeeting.ExportedSuccessfully' | translate }}</span>
        </h3>
        <div>
            <mat-dialog-actions class="text-right">
                <div class="w-100">
                    <button mat-button (click)="downloadExport()">
                        {{ 'GeneralMeeting.DownloadAndClose' | translate }}
                    </button>
                </div>
            </mat-dialog-actions>
        </div>
    </div>
}
<!-- export failed -->
@if (isDone && hasError) {
    <div>
        <h3 mat-dialog-title class="title-with-icon">
            <mat-icon class="color-error">close</mat-icon>
            <span>{{ 'GeneralMeeting.ExportFailed' | translate }}</span>
        </h3>
        @if (!currentMeeting) {
            <div class="color-error">{{ 'GeneralMeeting.NoCurrentGm' | translate }}</div>
        }
        <div>
            <mat-dialog-actions class="text-right">
                <div class="w-100">
                    <button mat-button mat-dialog-close>{{ 'General.Close' | translate }}</button>
                </div>
            </mat-dialog-actions>
        </div>
    </div>
}
